import Super from './section-break-input';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireSectionBreakReview extends Super {}
